


var lang = document.documentElement.lang || "pt-BR";
moment.locale(lang);

/* --- Defaults Options --- */
// - Datepicker options
var dpOptions = {
  language: lang,
  autoclose: true,
};

// - Typeahead options
var taOptions = {
  minLength: 3,
  highlight: true,
};

// - Form class
var Form = function (selectorValue, cb) {
  selectorValue = selectorValue || "form";
  this.element = $(selectorValue).not(".app-logout-form");
  this.selector = selectorValue;
  this.validator = null;

  this.element
    .find('input[type="text"]')
    .not(".autocomplete")
    .attr("autocomplete", "off");
  this.element
    .find('input[type="text"].autocomplete')
    .attr("autocomplete", "on");

  // The interceptor stays bound for the whole page life. The previous pattern
  // ($(this).off("submit").submit()) removed the only submit handler on the first
  // submission, leaving the form unguarded until rails-ujs disabled the buttons
  // (a setTimeout of 13ms): a second click inside that window (hardware double-fire)
  // produced a second raw POST and duplicated transactions (FZ-406). Re-entries are
  // now swallowed by the "submitting" flag, and the native DOM submit() below does
  // not re-dispatch jQuery handlers, so no unbinding is needed.
  this.element.off("submit.hospedinForm").on("submit.hospedinForm", function (event) {
    event.preventDefault();

    if ($(this).data("hospedinSubmitting")) {
      return;
    }

    if ($(this).valid()) {
      $(this).data("hospedinSubmitting", true);
      Masks.unMasks();
      $("#flash_message_validate").addClass("hidden");
      this.submit();
    } else {
      Masks.setMasks();
      $("#flash_message_validate").removeClass("hidden");
      $(window).scrollTop(0);
    }

    if (cb && typeof cb === "function") {
      cb();
    }
  });
};

// Voltar pelo navegador restaura a página da memória (back/forward cache) do jeito que estava no
// envio: com a marca de "enviando" e os campos sem máscara. Sem limpar, o formulário não enviava de
// novo (o jquery_ujs reabilita o botão, mas o handler acima engolia o submit).
$(window)
  .off("pageshow.hospedinForm")
  .on("pageshow.hospedinForm", function (event) {
    if (!event.originalEvent || !event.originalEvent.persisted) return;
    $("form").removeData("hospedinSubmitting");
    Masks.setMasks();
  });

// - Datepicker method
Form.prototype.datepicker = function (inputSelector, options) {
  if (typeof inputSelector === "object") {
    options = inputSelector;
    inputSelector = null;
  }

  options = options ? Object.assign({}, dpOptions, options) : dpOptions;
  inputSelector = inputSelector || ".datepicker";

  return this.element.find(inputSelector).datepicker(options);
};

Form.prototype.daterangepicker = function (
  inputSelector,
  validator,
  options,
  format,
  cb
) {
  inputSelector = inputSelector || ".daterange";

  format = format || "DD/MM/YYYY";

  var defaultOptions = {
    timePicker: false,
    autoUpdateInput: false,
    autoApply: true,
  };

  options = $.extend({}, defaultOptions, options);

  this.element.find(inputSelector).daterangepicker(options);

  this.element
    .find(inputSelector)
    .on("apply.daterangepicker", function (ev, picker) {
      $(this).val(
        picker.startDate.format(format) + " - " + picker.endDate.format(format)
      );

      if (validator) {
        validator.element(this);
      }
      if (cb && typeof cb === "function") {
        cb(ev, picker, format);
      }
    });
  this.element
    .find(inputSelector)
    .on("cancel.daterangepicker", function (ev, picker) {
      $(this).val("");
    });
};

// - Typeahead method
Form.prototype.typeahead = function (path, model, options, selector, extend) {
  options = options ? Object.assign({}, taOptions, options) : taOptions;
  extend = extend || "";

  var remote = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace(model),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    // `prefetch: false` deixa só a busca remota: nada é baixado ao carregar a página.
    prefetch: options.prefetch === false ? undefined : path,
    remote: {
      url: path + "?search=%QUERY&field=" + model + extend,
      wildcard: "%QUERY",
    },
  });

  selector = selector || "." + model + "-remote";

  this.element.find(selector).typeahead(
    {
      minLength: options.minLength,
      highlight: options.highlight,
    },
    {
      name: "search-" + model,
      display: model,
      source: remote,
    }
  );
};

// - Validate method
Form.prototype.validate = function (rules, messages) {
  return (this.validator = this.element.validate({
    onfocusout: function (element) {
      this.element(element);
    },
    errorClass: "state-error",
    validClass: "state-success",
    errorElement: "em",
    success: function (label, element) {
      label.parent().removeClass("error");
      label.remove();
    },
    rules: rules || {},
    messages: messages || {},
    highlight: function (element, errorClass, validClass) {
      $(element).addClass("input-error");
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass("input-error");
    },
    errorPlacement: function (error, element) {
      if (element.is(":radio") || element.is(":checkbox")) {
        element.closest(".option-group").after(error);
      } else {
        error.insertAfter(element.parent());
      }
    },
  }));
};

// -- Remove Image
Form.prototype.remove_image = function (route) {
  var button = $("#btn-remove-image");
  route = route || $(button).data("url");
  button.click(function () {
    var data = {};
    data[$(this).data("object")] = { remove_image: 1 };
    $.ajax({
      url: accountSlugUrl("/" + route + "/" + $(this).data("id")),
      method: "PUT",
      dataType: "json",
      data: data,
      success: function (response) {
        $("#btn-remove-image, #img-upload, #message-picture").addClass(
          "hidden"
        );
        $("#img-upload-placeholder").removeClass("hidden");
      },
    });
  });
};

// -- Select2
Form.prototype.select2 = function (selector, options) {
  options = options ? options : {};

  this.element.find(selector ? selector : "select.select2").each(function () {
    $(this).select2(
      $.extend(
        {
          dropdownParent: $(this).parent(),
          width: "100%",
        },
        options
      )
    );
  });
};

Form.prototype.getFormData = function (mapArray) {
  var self = this;
  var obj = {};

  $.each(mapArray, function (i, value) {
    obj[value[0]] = self.element.find(value[1]).val();
  });

  return obj;
};

Form.prototype.resetData = function (selectors) {
  var self = this;

  $.each(selectors, function (i, selector) {
    var ele;
    var value = "";

    if (selector && typeof selector === "string") {
      ele = self.element.find(selector);
    } else {
      ele = self.element.find(selector.name);
      value = selector.value;
    }

    ele.val(value);

    if (ele.hasClass("select2")) {
      ele.trigger("change");
    }

    if (ele.hasClass(".tt-input")) {
      ele.typeahead("val", value);
    }
  });
};

Form.prototype.handleRecurrenceField = function () {
  $("#transaction_repeat").change(function () {
    if ($(this).prop("checked")) {
      $("#recurrence_fields").removeClass("hidden");
    } else {
      $("#recurrence_fields").addClass("hidden");
    }
  });
};

Form.prototype.autoTrim = function () {
  $(".trim").blur(function () {
    $(this).val($(this).val().trim());
  });
};

Form.prototype.paletteColorPicker = function (selector, options) {
  $(selector).paletteColorPicker(
    Object.assign(
      {},
      {
        position: "downside",
        clear_btn: null,
      },
      options
    )
  );
};

Form.prototype.colorPicker = function (inputSelector, pickrSelector) {
  var defaultValue = $(inputSelector).val();

  var pickr = Pickr.create({
    el: pickrSelector,
    theme: "monolith",
    default: defaultValue,
    components: {
      preview: true,
      hue: true,
      interaction: {
        input: true,
        save: true,
      },
    },
    strings: {
      save: "Salvar",
    },
  });

  pickr.on("save", function (color, instance) {
    $(inputSelector).val(color.toHEXA().toString());
    instance.hide();
  });

  $(inputSelector).on("change", function () {
    pickr.setColor($(this).val());
  });
};

Form.prototype.addAnother = function () {
  var form = this;
  $btn = form.element.find(".add-another-button");
  $flagAddAnother = form.element.find(".add-another-flag");

  if ($btn.length && $flagAddAnother.length) {
    $btn.on("click", function (e) {
      e.preventDefault();
      $flagAddAnother.val(true);
      form.element.trigger("submit");
    });
  }
};
